export default __webpack_public_path__ + "assets/f18faacee990ac53ba6982c03ebf9d9f.png";